<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>中文官网</el-breadcrumb-item>
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item>合作伙伴</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="operating">
      <span>
        <el-button type="primary" size="small"  @click="addDialog">新增</el-button>
      </span>
    </div>
    <div>
      <el-table
        :data="tableData"
        stripe
        center
        border
        highlight-current-row
        style="width: 100%">
        <el-table-column
          align="center"
          label="排序"
          width="120"
          prop="sequence">
          <template slot-scope="scope">
            <el-input type="number"  size="small" v-model.number="scope.row.sequence" min="0" max="1000" @change="changeSort(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="类型"
          :formatter="typeFormatter"
          prop="type">
        </el-table-column>
        <el-table-column
          align="center"
          label="预览图">
          <template slot-scope="scope">
            <el-image :src="scope.row.file.file_path" :preview-src-list="[scope.row.file.file_path]" alt="" style="height: 40px">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          width="80">
          <template slot-scope="scope" >
            <el-popconfirm
              confirmButtonText='确定'
              cancelButtonText='返回'
              icon="el-icon-info"
              iconColor="red"
              title="删除不可恢复，确定删除吗？"
              @onConfirm="del(scope.row.id)"
            >
              <el-button type="primary"  size="small" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="closeHandle"
      width="600px"
      class="padding_10"
    >
      <el-form :model="form" :rules="rules" label-width="120px" ref="form">
        <el-form-item label="类型" prop="type" >
          <el-select v-model="form.type" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业LOGO" prop="file_id"  style="text-align: left!important;">
          <el-upload
            class="upload-demo"
            action="#"
            :before-upload="beforeAvatarUpload"
            :on-change="handleChange"
            :http-request="uploadImg"
            list-type="picture"
            :file-list="fileList"
            :on-remove="handleRemove"
            ref="upload"
            prop="file_id">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" style="color: red;font-size: 14px;margin-left: 8px" class="el-upload__tip">注意图片尺寸</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          :loading="loading"
          @click="addHandle"
        >保 存</el-button>
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {uploadImg} from '../../api'
import {partnerAdd, partnerDel, partnerPage, partnerSequence} from '../../api/partner'

export default {
  data () {
    return {
      tableData: [],
      dialogTitle: '',
      dialogVisible: false,
      loading: false,
      form: {
        type: '',
        file_id: ''
      },
      rules: {
        type: [
          {required: true, message: '请输入类型'}
        ],
        file_id: [
          {required: true, message: '请选择LOGO'}
        ]
      },
      types: [
        {
          value: 1,
          label: '合作企业'
        },
        {
          value: 2,
          label: '合作平台'
        }
      ],
      fileList: [],
      file: {}
    }
  },
  mounted () {
    this.setTableData()
  },
  methods: {
    // 删除
    del (id) {
      partnerDel({partner_id: id}).then(res => {
        this.$notify({
          message: res.message,
          type: res.status === 2000 ? 'success' : 'warning',
          offset: 100,
          showClose: false
        })
        if (res.status === 2000) {
          this.setTableData()
        }
      })
    },
    // 排序更新
    changeSort (row) {
      partnerSequence({partner_id: row.id, sequence: row.sequence}).then(res => {
        this.$notify({
          message: res.message,
          type: res.status === 2000 ? 'success' : 'warning',
          offset: 100,
          showClose: false
        })
        if (res.status === 2000) {
          this.setTableData()
        }
      })
    },
    // 类型处理
    typeFormatter (ow, column, cellValue, index) {
      let type = this.types.find(item => item.value === cellValue)
      return type ? type.label : '-'
    },
    // 表格数据
    setTableData () {
      partnerPage().then(res => {
        if (res.status === 2000) {
          this.tableData = res.data
        } else {
          this.tableData = []
        }
      })
    },
    // 关闭弹窗
    closeHandle () {
      this.dialogTitle = ''
      this.$refs['form'].resetFields()
    },
    // 上传前回调
    beforeAvatarUpload (file) {
      const isImg = ['image/jpeg', 'image/png', 'image/jpg'].indexOf(file.type) >= 0
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImg) {
        this.$notify({
          message: '上传图片必须为jpg或png 格式!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      if (!isLt2M) {
        this.$notify({
          message: '上传图片大小不能超过 2MB!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      return isImg && isLt2M
    },
    // 上传文件，获取文件流
    handleChange (file) {
      this.file = file.raw
    },
    // 文件上传
    uploadImg () {
      this.$refs.upload.clearFiles()
      // 创建表单对象
      let form = new FormData()
      // 后端接受参数 ，可以接受多个参数
      form.append('file', this.file)
      uploadImg(form).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.form.file_id = res.data.file_id
          this.fileList = [{
            name: res.data.file_name,
            url: res.data.file_path
          }]
        }
        this.$notify({
          message: message,
          type: status === 2000 ? 'success' : 'warning',
          offset: 100,
          showClose: false
        })
        this.$refs.upload.clearFiles()
      })
    },
    // 文件删除回调
    handleRemove () {
      this.form.file_id = ''
      this.fileList = []
    },
    // 保存添加
    addHandle () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          partnerAdd(this.form).then(res => {
            if (res.status === 2000) {
              this.dialogVisible = false
              this.setTableData()
            }
            this.loading = false
            this.$notify({
              message: res.message,
              type: res.status === 2000 ? 'success' : 'warning',
              offset: 100,
              showClose: false
            })
          })
        }
      })
    },
    // 添加弹窗
    addDialog () {
      this.dialogTitle = '新增合作伙伴'
      this.dialogVisible = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/partner/index.vue